import React, { useState } from 'react'
import { useStore } from '../../../StateProvider'
import { map } from 'ramda'
import { useResidenceDependentVisibility } from '../../utils/hooks'
import { ExternalSelect } from '..'

const residenceDependentFields = ['annualIncomeId']

/**
 * @param {string} label
 * @param {string} name
 * @param {string} additionalInfo
 * @param {string[]} requiredForCountries
 */
const ExternalSelectResidenceDependent = ({ label, name, additionalInfo, requiredForCountries }) => {
  const [isShown, setIsShown] = useState(
    !requiredForCountries ||
    !requiredForCountries.length ||
    !residenceDependentFields.includes(name)
  )
  const [{ form, form: { accId } }, dispatch] = useStore()
  const { residenceCountry } = form[accId]

  const onHide = () => {
    setIsShown(false)
    dispatch({ type: 'removeValidationFld', name })
  }

  const onShow = () => {
    setIsShown(true)
    dispatch({ type: 'addValidationFld', name })
  }

  useResidenceDependentVisibility({
    residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
  })

  return isShown ? (
    <ExternalSelect
      label={label}
      name={name}
      additionalInfo={additionalInfo}
    />
  ) : null
}

const getExternalSelectResidenceDependentFields = map(currencyField => {
  return (
    <ExternalSelectResidenceDependent
      {...currencyField}
      label={currencyField.i18n ? `generatedField.${currencyField.i18n}` : ''}
      key={currencyField.name}
    />
  )
})

export { ExternalSelectResidenceDependent, getExternalSelectResidenceDependentFields }
